import React, { useEffect, useState } from 'react';
import { getSimpleDateFormat, getUserName } from 'utils/functions';
import './styles.scss';
import UserProfileSideModal from './user-profile-side-modal';
import { apiService } from 'utils/api';
import { useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as EmptyIcon } from 'assets/icons/empty-search-result.svg';
import { Table, TableData, TableRow } from '@cokitchen/cokitchen-components';
import UserResultMobile from './user-result-mobile';
import { UserType } from 'models/user.model';
import CSUserProfileSideModal from 'components/cs/modals/user-profile-modal';
import { STORAGE_KEYS } from 'utils/constants';
import { ENUM_CS_ROLE, ENUM_ROLE } from '@cokitchen/cokitchen-auth';

const TABLE_HEADERS = [
  'Name',
  'Date Joined',
  'Phone number',
  'Email',
  'Wema Acct(Bani)',
  'Providus Acct(Bani)',
  'Free Deliveries',
  ''
];
const UserResultTable = () => {
  const [showViewProfileModal, setShowViewProfileModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(false);
  const [loading, setLoading] = useState(false);
  const [localOrders, setLocalOrders] = useState<UserType[]>([]);
  const [total, setTotal] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [userId, setUserId] = useState<string>('');
  const storeRole = localStorage.getItem(STORAGE_KEYS.ROLE) as ENUM_ROLE;

  const { filterType: filter_type, filterValue: filter_value } = useParams();
  const navigate = useNavigate();
  if (!filter_value || !filter_type) navigate(-1);

  const fetchListItems = async () => {
    setLoading(true);
    const filter = { filter_type, filter_value, page: pageNumber };
    const res = await apiService.get(`cs/search/keyword`, {
      params: filter,
      baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
    });
    const { data, total } = res.data;
    setTotal(total);
    setLocalOrders(data);
    setLoading(false);
  };

  useEffect(() => {
    updatePageNumber({ selected: 0 });
  }, []);

  useEffect(() => {
    if (!showViewProfileModal) fetchListItems();
  }, [pageNumber, showViewProfileModal]);

  const viewProfile = (user: any) => {
    setSelectedUser(user);
    setShowViewProfileModal(true);
    setUserId(user.id);
  };

  const updatePageNumber = async (val: { selected: number }) => {
    const pageNo = val?.selected + 1;
    setPageNumber(pageNo);
  };

  return (
    <div>
      {localOrders.length === 0 && !loading ? (
        <div className='flex justify-center items-center'>
          <div>
            <EmptyIcon />
            <p className='py-3'>No search result found</p>
          </div>
        </div>
      ) : (
        <Table
          hideOnMobile
          headers={TABLE_HEADERS}
          loading={loading}
          pageCount={Math.ceil(total / 10)}
          onPageChange={updatePageNumber}
          mobileContent={<UserResultMobile users={localOrders} onSelect={viewProfile} />}>
          {localOrders?.map((item, index) => (
            <TableRow key={index}>
              <TableData className='text-left py-6'>{getUserName(item)}</TableData>
              <TableData className='text-left text-[#858585]'>
                <span>{getSimpleDateFormat(item.created_at)}</span>
              </TableData>
              <TableData>{item?.phone_number}</TableData>
              <TableData>{item?.email}</TableData>
              <TableData>
                {item?.bani_account_number || (
                  <div className='flex justify-center bg-[#F0F0F0] border border-1 border-[#DEDEDE] text-[#858585] w-[100px] py-1 rounded-sm'>
                    Not available
                  </div>
                )}
              </TableData>
              <TableData>
                {item?.bani_account_number_providus || (
                  <div className='flex justify-center bg-[#F0F0F0] border border-1 border-[#DEDEDE] text-[#858585] w-[100px] py-1 rounded-sm'>
                    Not available
                  </div>
                )}
              </TableData>
              <TableData className='text-center text-green-5'>{item?.free_deliveries}</TableData>
              <TableData>
                <button className='underline text-[#E60A2B]' onClick={() => viewProfile(item)}>
                  View Profile
                </button>
              </TableData>
            </TableRow>
          ))}
        </Table>
      )}

      {Object.values<string>(ENUM_CS_ROLE).includes(storeRole) ? (
        <CSUserProfileSideModal
          show={showViewProfileModal}
          closeModal={() => setShowViewProfileModal(false)}
          id={userId}
        />
      ) : (
        <UserProfileSideModal
          show={showViewProfileModal}
          closeModal={() => setShowViewProfileModal(false)}
          user={selectedUser}
        />
      )}
    </div>
  );
};

export default UserResultTable;
